import { useCustomUpdateProjectMapMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateProjectMap() {
  const [mutation, { loading, error, data }] = useCustomUpdateProjectMapMutation({
    refetchQueries: ["customGetProjectMap"],
  });

  const [updateProjectMap, context] = useBitumioMutation(
    {
      mutation,
      loading,
      error,
      data,
      key: "updateProjectMap",
    },
    {
      hideMessage: true,
    }
  );

  return [updateProjectMap, context] as const;
}
